/*
 * Copyright (c) 2025. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import * as z from 'zod';
export const costDatabaseQuerySchema = z.object({
    search: z.string().optional(),
    type: z.enum(['hv', 'pv', 'bess']),
    limit: z.int().default(100),
    showArchived: z.boolean().default(false),
    minVersion: z.int().min(0).default(0),
    maxVersion: z.int().min(0).default(10),
});
//# sourceMappingURL=costing.js.map